import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './StudioApp';
import './styles/variables.css';
import './styles/globals.css';
import './styles/studio.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
